import React, { Component } from 'react';
import SimpleSlider from '../../components/slider';
import { ProductSolution } from '../../components/productSolution';
import { Tabs } from '../../components/tabs';
import { NewsEvent } from '../../components/newsEvent';

import banner1 from './images/banner1.jpg';
import banner2 from './images/banner2.jpg';
import ptype1 from './images/ptype1.png';
import ptype2 from './images/ptype2.png';
import ptype3 from './images/ptype3.png';
import ptype4 from './images/ptype4.png';

import driver1 from './images/driver@1.jpg';
import driver2 from './images/driver@2.jpg';
import driver3 from './images/driver@3.jpg';
import driver4 from './images/driver@4.jpg';

import newsEvent1 from './images/newsEvent1.jpg';
import newsEvent2 from './images/newsEvent2.jpg';
import newsEvent3 from './images/newsEvent3.jpg';

var bannerImg1 = {
    background: 'url(' + banner1 + ') center no-repeat'
}

var bannerImg2 = {
    background: 'url(' + banner2 + ') center no-repeat'
}

var driverBgImg1 = {
  background:'url(' + driver1 + ') center no-repeat'
}

var driverBgImg2 = {
  background:'url(' + driver2 + ') center no-repeat'
}
var driverBgImg3 = {
  background:'url(' + driver3 + ') center no-repeat'
}

var driverBgImg4 = {
  background:'url(' + driver4 + ') center no-repeat'
}


var newsArray = [
  {
    img:newsEvent1,
    title:'深圳前海股权交易中心成功挂牌',
    detail:'2017年5月25日，伴随着喜庆的锣声，深圳市新运力科技开发有限公司在深圳前海股权交易中心成功挂牌。'
  },
  {
    img:newsEvent2,
    title:'新运力科技”获得1.6亿元融资',
    detail:'2017年10月8日，深圳新运力科技董事长夏朝光先生与三家投资人签署完成1.6亿元的A轮投资协议，并获得银行授信3亿元。'
  },
  {
    img:newsEvent3,
    title:'授牌《诚信公约联盟联合惩戒单位》',
    detail:'央视报道：2018年6月1日，新运力受邀参加了海口“第二届诚信互联大会”，并接受《诚信公约联盟联合惩戒单位》授牌，成为集装箱运输服务业首批具备上报“黑名单”、联合惩戒“黑名单”的平台。'
  },

]


class Home extends Component {
  componentDidMount(){
    window.scrollTo(0,0);
  }
  render() {
    return (
      <div className="home">

        <SimpleSlider bannerBgimgUrl = {[bannerImg1,bannerImg2]}/>
        <ProductSolution ptype1={ptype1} ptype2={ptype2} ptype3={ptype3} ptype4={ptype4}/>
        <Tabs driverBgImg1={driverBgImg1} driverBgImg2={driverBgImg2} driverBgImg3={driverBgImg3} driverBgImg4={driverBgImg4}/>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/pages/home/index.js